import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import React from 'react';
import { SizeMe } from 'react-sizeme';
import classnames from 'classnames';
import TruncateByLength from './TruncateByLength';
import TruncateByWidth from './TruncateByWidth';
import { wrapperClassName } from './constants';
import { SWrapper } from './styles';
/**
 * @public
 */

/**
 * @public
 */

var Truncate = function Truncate(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'length' : _ref$type,
      value = _ref.value,
      threshold = _ref.threshold,
      tooltip = _ref.tooltip,
      showTooltip = _ref.showTooltip,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'r' : _ref$align,
      _ref$omission = _ref.omission,
      omission = _ref$omission === void 0 ? '...' : _ref$omission,
      tooltipMaxWidth = _ref.tooltipMaxWidth,
      className = _ref.className,
      style = _ref.style,
      updaterRef = _ref.updaterRef,
      isOverflowChange = _ref.isOverflowChange;

  var actuallShowTooltip = function () {
    // 旧版组件支持tooltip prop，且'enable'表示true
    if (showTooltip !== undefined) return showTooltip;

    if (tooltip !== undefined) {
      return tooltip === true || tooltip === 'enable';
    }

    return true;
  }();

  var actualThreshold = function () {
    if (threshold !== undefined) {
      return threshold;
    }

    if (value !== undefined) {
      // 旧版API： value可以为30、'30'、'30px'
      if (typeof value === 'number') {
        // value可以是40
        return value;
      }

      var parsed = parseInt(value, 10);

      if (!Number.isNaN(parsed)) {
        // value可以是'40'
        return parsed;
      }

      if (type === 'width' && typeof value === 'string') {
        // 仅当type为'width'时，value可以是'40px'这种【非纯数字字符串】
        return value;
      }

      console.error("type can't be string unless type is 'width', using default: 30");
    }

    return 30;
  }();

  if (type === 'length' && // type 视为 'length' 的前提：
  typeof children === 'string' && actualThreshold !== 'auto') {
    return React.createElement(Wrapper, {
      className: className,
      style: style
    }, React.createElement(TruncateByLength, {
      threshold: actualThreshold,
      omission: omission,
      showTooltip: actuallShowTooltip,
      align: align,
      tooltipMaxWidth: tooltipMaxWidth
    }, children));
  } // 其余情况 type 视为 'width'


  if (actualThreshold === 'auto') {
    return React.createElement(SizeMe, null, function (_ref2) {
      var size = _ref2.size; // 获得可用宽度（即Wrapper的宽度）

      var actualActualThreshold; // 设置一个超大的Threshold，使得react-sizeme能拿到完整内容的宽度

      if (!size.width) actualActualThreshold = 5000;else actualActualThreshold = size.width;
      return React.createElement(Wrapper, {
        className: className,
        style: style
      }, React.createElement(TruncateByWidth, {
        threshold: actualActualThreshold,
        omission: omission,
        showTooltip: actuallShowTooltip,
        align: align,
        tooltipMaxWidth: tooltipMaxWidth,
        updaterRef: updaterRef,
        isOverflowChange: isOverflowChange
      }, children));
    });
  }

  return React.createElement(Wrapper, {
    className: className,
    style: style
  }, React.createElement(TruncateByWidth, {
    threshold: actualThreshold,
    omission: omission,
    showTooltip: actuallShowTooltip,
    align: align,
    tooltipMaxWidth: tooltipMaxWidth,
    updaterRef: updaterRef,
    isOverflowChange: isOverflowChange
  }, children));
};

export default Truncate;

var Wrapper = function Wrapper(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      style = _ref3.style;
  return React.createElement(SWrapper, {
    className: classnames(wrapperClassName, className),
    style: style
  }, children);
};